import InputHelper from '@/plugins/InputHelper'
import AbstractNumberValidator from '@/plugins/validator/number/AbstractNumberValidator'


// Decorator for number input
export default class InputNumberValidator extends AbstractNumberValidator{

  constructor(conmponent, input, fieldSchema, context){
    super()
    this.component = conmponent
    this.input = input
    this.fieldSchema = fieldSchema
    this.context = context
  }

  getValue(){
    return   this.input.value
  }

  getFieldValue(fieldInterface){
    return InputHelper.getAnswer(fieldInterface, this.component.getParent().getFieldValue(fieldInterface.id))
  }

  getFieldInterface(id){
      return this.context.getFieldInterface(id)
  }

}
